(() => {
  if (!('IntersectionObserver' in window)) return;

  const targets = document.querySelectorAll('[data-reveal-group], [data-reveal-grid]');
  if (!targets.length) return;

  // Force the browser to commit the hidden state in one frame before adding
  // is-revealed on the next, otherwise elements already in the viewport at
  // load can flip straight to visible with nothing to transition from.
  const reveal = (el) => {
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        el.classList.add('is-revealed');
      });
    });
  };

  const observer = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (entry.isIntersecting) {
          reveal(entry.target);
          observer.unobserve(entry.target);
        }
      }
    },
    { threshold: 0.15, rootMargin: '0px 0px -60px 0px' }
  );

  targets.forEach((target) => observer.observe(target));
})();
